var map = {
	"./ATCODER.png": "9dd1",
	"./CODECHEF.png": "d76c",
	"./CODEFORCES.png": "59e6",
	"./HACKEREARTH.png": "c787",
	"./HACKERRANK.png": "27d2",
	"./ICPC.png": "3156",
	"./SPOJ.png": "6c6e",
	"./TOPCODER.png": "0c11",
	"./UNKNOWN_COMPETITIVE_SITE.png": "2e2b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ae7b";